/* eslint-disable */
export default {
  noActiveCalls: 'Sem chamadas ativas',
  noRecords: 'Não foram encontrados resultados.',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noRecords"@#@ @source: @#@"No results found."@#@
